import { ChatUnreadConversation } from "@/models/chat/chat-unread-conversation";
import { Conversation } from "@/models/chat/conversation";
import { Thread } from "@/models/chat/thread";
import { ChatSettings } from "@/models/user-configs/chat-settings";
import { ChatService } from "@/services/chat-service";
import { UserConfigService } from "@/services/user-config-service";

export class ChatState {

	totalThreads: number = 0;
	openedThread: null | Thread = null;
	openedConversation: null | Conversation = null;
	conversationList: Conversation[] = [];
	conversationUnreads: ChatUnreadConversation[] = [];
	settings: ChatSettings = new ChatSettings();

	async fetchThread(threadId: number) {
		if (threadId == 0) {
			this.openedThread = null;
			return;
		}
		if (this.openedThread && threadId == this.openedThread.ID) {
			return;
		}
		this.openedThread = await ChatService.getThread(threadId);
	}

	async fetchThreads() {

		let threads = await ChatService.getThreads();
		this.totalThreads = threads.length;

	}

	async fetchConversations() {
		this.conversationList = await ChatService.getAllConversations();
	}

	async fetchUnreads() {
		this.conversationUnreads = await ChatService.getUnreads();
	}

	async fetchSettings() {
		this.settings = await UserConfigService.getChatSettings();
	}

	async saveSettings() {
		if(this.settings)
			UserConfigService.setChatSettings(this.settings);
	}

}